import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

declare var require: any;
import * as _ from 'lodash-es';

@Component({
  selector: 'app-monitor-assignment-summary',
  templateUrl: './monitor-assignment-summary.component.html',
  styleUrls: ['./monitor-assignment-summary.component.scss']
})
export class MonitorAssignmentSummaryComponent implements OnInit {

  monitors: any;

  monitor = '';
  group = '';
  search = '';

  monitorsList: any = [];
  groups: any = [];

  u = Utils;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getMonitors();

  }

  getMonitors(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    if(this.search == null){
      this.search = '';
    }

    this.okService.get('reports/monitors',{monitor:this.monitor,group:this.group,search:this.search})
    .subscribe((data) => {

      this.monitors = _.sortBy(data.body, ['monitor_name']);
      
      this.groups = this.okService.groups;
      this.monitorsList = this.okService.monitors;

    });
  }

  updateFilter(){
    this.getMonitors();
  }

  clearFilter(){
    this.monitor = '';
    this.group = '';
    this.search = '';
    this.updateFilter();
  }

  export(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    if(this.search == null){
      this.search = '';
    }

    let fields:any = {'export':true};
    fields['monitor'] = this.monitor;
    fields['group'] = this.group;
    fields['search'] = this.search;


    this.okService.download("reports/monitors",fields);

  }

}

